import api from './api-service'
import i18n from '../i18n'

export default {
    sendOrder(cartItems, reference, commentary, totalPrice, salesAgent = undefined) {
        return api.send('/order.json', i18n.t('responses.order'), {
            cart_items: cartItems,
            reference: reference,
            commentary: commentary,
            total_price: totalPrice,
            sales_agent_id: salesAgent
        })
    },

    getSpecificOrder() {
        return api.retrieve(`/last_order.json`, i18n.t('responses.order'))
    }
}